export default {
  base_url: 'https://api.qa.ronad.ir/api',
  warehouses: [ 
    {
      "id" : 29,
      "name" : "انبار غرب تهران",
      "phoneNumber" : "02121212121",
      "city" : "تهران",
      "zipCode" : null,
      "lat" : 35.724984098857576,
      "lon" : 51.55222742865983,
      "capacity" : 4000000,
      "workDays" : "شنبه تا جمعه",
      "workTimes" : "8 الی 20",
      "province" : "تهران",
      "address" : "تهران خیابان دماوند",
      "adminId" : 221,
      "parentId" : null,
      "centerId" : null,
      "cityId" : 1,
      "status" : "ACTIVE"
    },{
    "id" : 82,
    "name" : "انبار تست چند ادمینی",
    "phoneNumber" : "02144332255",
    "city" : "تهران",
    "zipCode" : null,
    "lat" : 35.68734809950461,
    "lon" : 51.40851071895167,
    "capacity" : 10000,
    "workDays" : "5",
    "workTimes" : "8",
    "province" : "تهران",
    "address" : "تهران - تست",
    "adminId" : 24,
    "parentId" : null,
    "centerId" : null,
    "cityId" : 1,
    "status" : "ACTIVE"
  }, {
    "id" : 78,
    "name" : "تست ۱",
    "phoneNumber" : "02166666666",
    "city" : "تهران",
    "zipCode" : null,
    "lat" : 35.69020627089842,
    "lon" : 51.392841339111335,
    "capacity" : 100,
    "workDays" : "شنیه ها",
    "workTimes" : "۸-۱۷",
    "province" : "تهران",
    "address" : "تهران تهران تهران تهران تهران تهران تهران ",
    "adminId" : 121,
    "parentId" : null,
    "centerId" : null,
    "cityId" : 1,
    "status" : "ACTIVE"
  }, {
    "id" : 19,
    "name" : "انبار حکیمیه",
    "phoneNumber" : "09308167846",
    "city" : "تهران",
    "zipCode" : null,
    "lat" : 35.726615025951254,
    "lon" : 51.56295776367188,
    "capacity" : 1000,
    "workDays" : "شنبه تا پنجشنبه",
    "workTimes" : "10-22",
    "province" : "تهران",
    "address" : "سه راه تهرانپارس-اتوبان دماوند شرق- بعد از کندرو داتیس خودرو (خیابان شهید حقی)- نبش کوچه کاوه-پلاک۲۶۰",
    "adminId" : 137,
    "parentId" : null,
    "centerId" : null,
    "cityId" : 1,
    "status" : "ACTIVE"
  }, {
    "id" : 18,
    "name" : "بازی جهان2 ",
    "phoneNumber" : "02182536435",
    "city" : "تهران",
    "zipCode" : "5647243564",
    "lat" : 36.0,
    "lon" : 51.0,
    "capacity" : 1000,
    "workDays" : null,
    "workTimes" : null,
    "province" : "تهران",
    "address" : "مرکز تهران",
    "adminId" : null,
    "parentId" : null,
    "centerId" : null,
    "cityId" : 1,
    "status" : "ACTIVE"
  } ],
  destinationId: 19,
  centerId: 126
};
